<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <label for="bulkOrderGuid-field" class="form-label">Bulk Order</label>
  <select class="form-select preserve-spaces" name="bulkOrderGuid-field" id="bulkOrderGuid-field" formControlName="bulkOrderGuid" (change)="selectOnChange($event)">
    <option selected></option>
    @for (object of getDropdownDataObjectArray(); track object.id) {
      <option [ngValue]="object.id" [innerHTML]="object.description"></option>    
    }
  </select>
</form>
